module.exports = __webpack_public_path__ + "static/media/pencil-blue.8612c09c.svg";